import React from 'react'
import ReactDOM from 'react-dom/client'
import './apiClient.js' // installs the fetch interceptor before any API call
import App from './App.jsx'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
